import { render } from "./HeaderControl.vue?vue&type=template&id=37f106d1&scoped=true"
import script from "./HeaderControl.vue?vue&type=script&lang=js"
export * from "./HeaderControl.vue?vue&type=script&lang=js"

import "./HeaderControl.vue?vue&type=style&index=0&id=37f106d1&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f106d1"]])

export default __exports__